import React from "react";

export default function Icon({ name, size = 20, color = "#000", className }) {
  return (
    <svg
      width={size}
      height={size}
      style={{ color }}
      className={className}
      aria-hidden="true"
      focusable="false"
    >
      <use href={`#${name}`} />
      {/* Si jamais <use href> ne marche pas dans ton setup, remplace par:
          <use xlinkHref={`#${name}`} />
      */}
    </svg>
  );
}
